import * as XLSX from 'xlsx';

export interface AccountExportRow {
  orgId: number;
  orgPath: string;
  countryCode: string;
  empCount?: number;
  sessionCount?: number;
  parentOrgId?: number;
  isActive?: boolean;
  followUpUser?: {
    id: number;
    username: string;
    fullName: string;
  } | null;
  updatedAt: string;
}

const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleDateString('es-MX', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });

export const downloadAccountsExcel = (accounts: AccountExportRow[]) => {
  const rows = accounts.map((account) => ({
    'Org ID': account.orgId,
    Organización: account.orgPath,
    País: account.countryCode,
    Empleados: account.empCount ?? '',
    Sesiones: account.sessionCount ?? '',
    'Org Padre': account.parentOrgId ?? '',
    'Visible en formularios': account.isActive === false ? 'No' : 'Sí',
    'Usuario de seguimiento': account.followUpUser?.fullName ?? '',
    'Username seguimiento': account.followUpUser?.username ?? '',
    'Última Actualización': formatDate(account.updatedAt),
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Cuentas');

  const date = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(workbook, `catalogo-cuentas-${date}.xlsx`);
};
